import React from 'react'
import { StyledSelectForm, Props } from './styled'

export const SelectForm: React.FC<Props> = (props: Props) => {
  return <StyledSelectForm {...props} />
}
